import { FC, ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Collapse, Text, Avatar } from "@chakra-ui/react";
import { Minus, Plus } from "~/icons";
import AvatarSource from "~/images/lauren-profile.jpg";
import { CopyContainer } from "./CopyContainer";

interface Props {
  children: ReactNode;
  initialShow?: boolean;
}

export const CommentCollapsible: FC<Props> = ({
  children,
  initialShow = false,
}) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(initialShow);
  const handleToggle = () => setShow(!show);
  const Icon = show ? Minus : Plus;

  return (
    <Flex
      borderBottom="1px solid"
      borderTop="1px solid"
      borderColor="th.cream3"
      direction="column"
      py={2}
      textAlign="left"
      w="100%"
    >
      <Flex
        align="center"
        cursor="pointer"
        justify="space-between"
        onClick={handleToggle}
        w="full"
      >
        <Flex align="center">
          <Avatar height="2.25rem" mr={2} src={AvatarSource} width="2.25rem" />
          <Text variant="th-body1">{t("onboarding.laurenQuote.heading")}</Text>
        </Flex>
        <Icon w="1.5rem" h="1.5rem" />
      </Flex>
      <Collapse in={show}>
        <Flex ml={10} my={1}>
          <CopyContainer>{children}</CopyContainer>
        </Flex>
      </Collapse>
    </Flex>
  );
};
